//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import { Store } from '../../components/QSelectUtils.js'
import RequestWorkTypesList from './RequestWorkTypesList.vue'
import RequestWorkTypesPicker from './RequestWorkTypesPicker.vue'

export default {
  components: {
    RequestWorkTypesList
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    requestRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    workTypes: {
      type: Array,
      default () {
        return []
      }
    },
    workPackages: {
      type: Array,
      default () {
        return []
      }
    },
    workTypesInitial: {
      type: Array,
      default () {
        return []
      }
    },
    workPackagesInitial: {
      type: Array,
      default () {
        return []
      }
    },
    availableWorkTypes: {
      type: Array,
      default () {
        return []
      }
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      searchAmongSelected: false
    }
  },
  computed: {
    workTypesDialogLabel: function () {
      return 'ВЫБОР СОСТАВА РАБОТ ДЛЯ АВТОНАЗНАЧЕНИЯ'
    },
    workPackagesDialogLabel: function () {
      return 'ВЫБОР КОМПЛЕКСОВ РАБОТ ДЛЯ АВТОНАЗНАЧЕНИЯ'
    },
    workTypesEditable: function () {
      return this.requestRoles.hasEditAccess && !this.requestRoles.roleExternalDispatcher
    },
    workPackagesEditable: function () {
      return this.workTypesEditable
    },
    showWorkPackages: function () {
      return true
    },
    /**
     * @return {Array} Все назначенные работы заявки
     */
    allRequestWorkTypes: function () {
      const workTypes = this.request.workTypes ? this.request.workTypes.slice() : []
      // Комплексы работ
      if (this.request.workPackages) {
        this.request.workPackages.forEach(workPackage => workTypes.push(...workPackage.workTypes))
      }
      return workTypes
    },
    searchAmongSelectedLabel: function () {
      return this.searchAmongSelected ? 'Выбирать среди всех работ' : 'Выбирать среди назначенных работ'
    },
    workTypesSearchStore: function () {
      const getTypesFn = function () {
        if (this.searchAmongSelected) {
          return this.allRequestWorkTypes
        } else {
          return this.availableWorkTypes
        }
      }.bind(this)
      return new Store({
        itemsFn: getTypesFn,
        fullReadable: true,
        cached: false,
        searchable: true,
        alwaysShowUnselected: true
      })
    },
    workPackagesSearchStore: function () {
      const getPackagesFn = function () {
        const params = new URLSearchParams()

        params.set('workTypes', this.request.workTypes.map(o => o.id))
        params.set('workPackages', this.request.workPackages.map(o => o.id))
        params.set('includeSuitable', 'true')

        return axiosGet({
          url: '/service/delta/request/getWorkPackages?' + params.toString(),
          onSuccess: (response) => {
            const objects = response.data.result
            this.validateWorkPackages(objects)
            return objects
          },
          onFailure: 'Ошибка получения списка доступных для выбора комплексов работ',
          msgTarget: this
        })
      }.bind(this)
      return new Store({
        itemsFn: getPackagesFn,
        fullReadable: true,
        cached: false,
        searchable: true
      })
    }
  },
  watch: {
    allRequestWorkTypes: function (objects, objectsOld) {
      this.validateWorkTypes(objects)
    },
    searchAmongSelected: function (value) {
      localStorage.setItem('requestWorksSearchAmongSelected', value)
    }
  },
  created: function () {
    const searchAmongSelected = localStorage.getItem('requestWorksSearchAmongSelected')
    if (searchAmongSelected != null) {
      this.searchAmongSelected = searchAmongSelected === 'true'
    }
  },
  methods: {
    setWorkTypes: function (list) {
      if (!this.searchAmongSelected) {
        this.setNewItems(list, this.request.workTypes)
      }
      this.$emit('update:work-types', list)
    },
    setWorkPackages: function (list) {
      // this.setNewItems(list, this.request.workPackages)
      this.$emit('update:work-packages', list)
    },
    setNewItems: function (list, originList) {
      if (originList) {
        list.forEach(newItem => {
          const item = originList.find(item => item.id === newItem.id)
          if (!item) {
            originList.push(newItem)
          }
        })
      }
    },
    getAvailableWorkPackages: function () {
      const params = new URLSearchParams()

      // if (this.searchAmongSelected) {
      params.set('workTypes', this.request.workTypes.map(o => o.id))
      params.set('workPackages', this.request.workPackages.map(o => o.id))
      params.set('includeSuitable', 'true')
      // } else {
      //   if (this.request.requestType) {
      //     params.set('typeId', this.request.requestType)
      //   }
      //   // if (this.request.serviceObjectType) {
      //   //   params.set('objectType', this.request.serviceObjectType)
      //   // }
      // }

      return axiosGet({
        url: '/service/delta/request/getWorkPackages?' + params.toString(),
        onSuccess: (response) => {
          const objects = response.data.result
          this.validateWorkPackages(objects)
          return objects
        },
        onFailure: 'Ошибка получения списка доступных для выбора комплексов работ',
        msgTarget: this
      })
    },
    validateWorkTypes: function (availableObjects) {
      // Убираем из списка выбранных недоступные значения
      const filteredList = this.getFilteredObjectList(this.workTypes, availableObjects)
      if (filteredList != null) {
        this.setWorkTypes(filteredList)

        this.$q.notify({
          type: 'warning',
          message: 'Изменен список работ для автоназначения',
          progress: true,
          timeout: 5000
        })
      }
    },
    validateWorkPackages: function (availableObjects) {
      const filteredList = this.getFilteredObjectList(this.workPackages, availableObjects)
      if (filteredList != null) {
        this.setWorkPackages(filteredList)

        this.$q.notify({
          type: 'warning',
          message: 'Изменен список комплексов работ для автоназначения',
          progress: true,
          timeout: 5000
        })
      }
    },
    getFilteredObjectList: function (sourceObject, availableObjects) {
      const ids = new Set(availableObjects.map(o => o.id))
      if (sourceObject.find(o => !ids.has(o.id))) {
        return sourceObject.filter(o => ids.has(o.id))
      }
      return null
    },
    onAddWorkTypes: function () {
      const dialog = this.$d.dialog(this).show({
        noWrap: true,
        contentComponent: RequestWorkTypesPicker,
        contentProps: {
          store: this.workTypesSearchStore,
          headerLabel: this.workTypesDialogLabel,
          request: this.request,
          selectedItems: this.workTypes,
          mode: 'autoAssignWorkTypes',

          workTypes: this.workTypes,
          workPackages: this.workPackages
        },
        componentHandlers: {
          select: (selectedItems) => {
            this.setWorkTypes(selectedItems)
            this.$emit('changed-works', {
              newWorkTypes: selectedItems
            })
            dialog.hide()
          },
          cancel: () => {
            dialog.hide()
          }
        },
        persistent: true,
        maximized: true
      })
    },
    onAddWorkPackages: function () {
      const dialog = this.$d.dialog(this).show({
        noWrap: true,
        contentComponent: RequestWorkTypesPicker,
        contentProps: {
          store: this.workPackagesSearchStore,
          headerLabel: this.workPackagesDialogLabel,
          selectedItems: this.workPackages,
          request: this.request,
          mode: 'workPackages',

          workTypes: this.workTypes,
          workPackages: this.workPackages
        },
        componentHandlers: {
          select: (selectedItems) => {
            this.setWorkPackages(selectedItems)
            this.$emit('changed-works', {
              newWorkPackages: selectedItems
            })
            dialog.hide()
          },
          cancel: () => {
            dialog.hide()
          }
        },
        persistent: true,
        maximized: true
      })
    },
    onChangeWorkType: function (newWorkType) {
      const changedWorkTypeIndex = this.workTypes.findIndex(wT => wT.id === newWorkType.id)
      if (changedWorkTypeIndex !== -1) {
        this.$emit('update:work-types', this.workTypes.toSpliced(changedWorkTypeIndex, 1, newWorkType))
        this.$emit('changed-works', {
          changedWorkType: newWorkType
        })
      }
    },
    onChangeWorkTypeInPackage: function (workPackageId, newWorkType) {
      const workPackages = JSON.parse(JSON.stringify(this.workPackages))
      const workPackage = workPackages.find(wP => wP.id === workPackageId)
      if (workPackage) {
        const changedWorkTypeIndex = workPackage.workTypes.findIndex(wT => wT.id === newWorkType.id)
        if (changedWorkTypeIndex !== -1) {
          workPackage.workTypes = workPackage.workTypes.toSpliced(changedWorkTypeIndex, 1, newWorkType)
          this.$emit('update:work-packages', workPackages)
          this.$emit('changed-works', {
            changedWorkType: newWorkType,
            changedWorkPackageId: workPackageId
          })
        }
      }
    },
    onChangeWorkPackage: function (newWorkPackage) {
      const changedWorkPackageIndex = this.workPackages.findIndex(wP => wP.id === newWorkPackage.id)
      if (changedWorkPackageIndex !== -1) {
        this.$emit('update:work-packages', this.workPackages.toSpliced(changedWorkPackageIndex, 1, newWorkPackage))
      }
    },
    onDeleteWorkType: function (workType) {
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            const workTypeIndex = this.workTypes.findIndex(wT => wT.id === workType.id)
            this.$emit('update:work-types', this.workTypes.toSpliced(workTypeIndex, 1))
          }
        },
        header: 'Удалить?',
        warning: `Удалить работу ${workType.name}?`,
        buttons: {
          yes: 'Да',
          no: 'Нет'
        }
      })
    },
    onDeleteWorkPackage: function (workPackage) {
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            const workPackageIndex = this.workPackages.findIndex(wP => wP.id === workPackage.id)
            this.$emit('update:work-packages', this.workPackages.toSpliced(workPackageIndex, 1))
          }
        },
        header: 'Удалить?',
        warning: `Удалить комплекс работ ${workPackage.name}?`,
        buttons: {
          yes: 'Да',
          no: 'Нет'
        }
      })
    }
  }
}

